import {Component, Input} from '@angular/core';
import {EstadoOnboardingPainel, PASSOS_ONBOARDING, PassoOnboardingId} from '../onboarding-painel.service';

const VISUAL: Record<string, {icone: string; titulo: string}> = {
  cardapio: {icone: 'fas fa-book-open', titulo: 'Cardápio'},
  loja: {icone: 'fas fa-store', titulo: 'Como sua loja funciona'},
  pagamento: {icone: 'far fa-credit-card', titulo: 'Pagamento'},
  receber: {icone: 'fas fa-bell', titulo: 'Onde você recebe os pedidos'},
  teste: {icone: 'fas fa-shopping-bag', titulo: 'Seu primeiro pedido'}
};

/**
 * Cabeçalho comum dos passos: voltar, "Passo N de 5", ícone colorido, título e o vídeo curto. A variante "pergunta"
 * (telas de escolha, como o passo Cardápio) põe o voltar e os passos numa linha, o título grande em forma de pergunta
 * e o prêmio em pílula ao lado.
 */
@Component({
  selector: 'app-onb-moldura',
  template: `
    <ng-container *ngIf="variante === 'pergunta'; else padrao">
      <div class="onb-topo-passo">
        <a class="onb-voltar" routerLink="/admin/comecar"><i class="fas fa-chevron-left"></i> Primeiros passos</a>
        <div class="onb-segmentos" role="img" [attr.aria-label]="'Passo ' + numero + ' de ' + total">
          <span>Passo {{ numero }} de {{ total }}</span>
          <i *ngFor="let p of passos" [class.atual]="p.id === passo" [class.feito]="p.feito && p.id !== passo"></i>
        </div>
      </div>
      <div class="onb-pergunta">
        <div>
          <span class="onb-selo" *ngIf="selo"><i class="fas fa-magic" aria-hidden="true"></i> {{ selo }}</span>
          <h1>{{ titulo || visual.titulo }}</h1>
          <p class="onb-sub" *ngIf="subtitulo">{{ subtitulo }}</p>
        </div>
        <app-onb-bonus *ngIf="estado" [estado]="estado" formato="cartao"></app-onb-bonus>
      </div>
      <app-onb-video [passo]="passo"></app-onb-video>
    </ng-container>
    <ng-template #padrao>
      <a class="onb-voltar" routerLink="/admin/comecar"><i class="fas fa-chevron-left"></i> Primeiros passos</a>
      <div class="onb-eyebrow">Passo {{ numero }} de {{ total }}</div>
      <div class="onb-titulo">
        <span class="onb-ic onb-ic--{{ passo }}"><i [class]="visual.icone"></i></span>
        <h1>{{ titulo || visual.titulo }}</h1>
      </div>
      <p class="onb-sub" *ngIf="subtitulo">{{ subtitulo }}</p>
      <app-onb-video [passo]="passo"></app-onb-video>
      <app-onb-bonus class="onb-moldura-bonus" *ngIf="estado" [estado]="estado" formato="faixa"></app-onb-bonus>
    </ng-template>
    <ng-content></ng-content>
  `,
  styleUrls: ['./onb-moldura.component.scss']
})
export class OnbMolduraComponent {
  @Input() passo = 'cardapio';
  @Input() subtitulo = '';
  /** troca o nome do passo por uma pergunta quando a tela é de escolha (ex.: "De onde vamos montar seu cardápio?") */
  @Input() titulo = '';
  @Input() variante: 'padrao' | 'pergunta' = 'padrao';
  /** etiqueta acima do título na variante "pergunta" */
  @Input() selo = '';
  /** com o estado, o prêmio aparece como faixa logo abaixo do título */
  @Input() estado: EstadoOnboardingPainel | null = null;
  readonly total = PASSOS_ONBOARDING.length;

  get numero(): number { return PASSOS_ONBOARDING.indexOf(this.passo as any) + 1; }
  get visual(): {icone: string; titulo: string} { return VISUAL[this.passo] || VISUAL.cardapio; }

  /** segmentos da barra: os feitos em verde, o atual na cor do passo */
  get passos(): Array<{id: PassoOnboardingId; feito: boolean}> {
    return this.estado?.passos?.length ? this.estado.passos : PASSOS_ONBOARDING.map(id => ({id, feito: false}));
  }
}
